export { default as Box, type BoxProps } from './Box';
export { default as StylingBox, type StylingBoxProps } from './StylingBox';
export type { StylingProps } from './stylingProps';
export type { FontScale } from './stylingProps';
